import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../../api/axios";
import styles from "./Admin.module.css";

const STATUS_BADGE = {
  processing: "badge-amber", confirmed: "badge-purple",
  shipped: "badge-gray", delivered: "badge-green", cancelled: "badge-red",
};

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/dashboard").then(r => setData(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading-center"><div className="spinner"/></div>;

  const { stats, recentOrders, lowStockProducts, ordersByStatus } = data;

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h1 className={styles.title}>Dashboard</h1>
        <div className={styles.headerLinks}>
          <Link to="/admin/products" className="btn btn-ghost">Manage Products</Link>
          <Link to="/admin/orders" className="btn btn-primary">View All Orders</Link>
        </div>
      </div>

      <div className={styles.statsGrid}>
        {[
          { label: "Total Revenue", value: `₹${stats.totalRevenue.toLocaleString()}`, color: "var(--accent2)" },
          { label: "Total Orders", value: stats.totalOrders, color: "var(--green)" },
          { label: "Products", value: stats.totalProducts, color: "var(--amber)" },
          { label: "Customers", value: stats.totalUsers, color: "var(--text)" },
        ].map(stat => (
          <div key={stat.label} className={styles.statCard}>
            <div className={styles.statValue} style={{color: stat.color}}>{stat.value}</div>
            <div className={styles.statLabel}>{stat.label}</div>
          </div>
        ))}
      </div>

      <div className={styles.grid2}>
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h3 className={styles.sectionTitle}>Recent orders</h3>
            <Link to="/admin/orders" className={styles.viewAll}>View all →</Link>
          </div>
          {recentOrders.length === 0 ? (
            <div className="empty-state" style={{padding:"24px"}}><h3>No orders yet</h3></div>
          ) : recentOrders.map(order => (
            <Link to={`/order/${order._id}`} key={order._id} className={styles.orderRow}>
              <div>
                <div className={styles.orderId}>#{order._id.slice(-6).toUpperCase()}</div>
                <div className={styles.orderUser}>{order.user?.name}</div>
              </div>
              <span className={`badge ${STATUS_BADGE[order.orderStatus] || "badge-gray"}`}>{order.orderStatus}</span>
              <div className={styles.orderAmt}>₹{order.totalPrice?.toLocaleString()}</div>
            </Link>
          ))}
        </div>

        <div>
          <div className={styles.section} style={{marginBottom:"16px"}}>
            <h3 className={styles.sectionTitle} style={{marginBottom:"16px"}}>Orders by status</h3>
            {ordersByStatus.map(s => (
              <div key={s._id} className={styles.statusRow}>
                <span className={`badge ${STATUS_BADGE[s._id] || "badge-gray"}`}>{s._id}</span>
                <div className={styles.statusBar}>
                  <div className={styles.statusFill} style={{width: `${Math.min(100, (s.count / stats.totalOrders) * 100)}%`}}/>
                </div>
                <span className={styles.statusCount}>{s.count}</span>
              </div>
            ))}
          </div>

          <div className={styles.section}>
            <div className={styles.sectionHeader}>
              <h3 className={styles.sectionTitle}>Low stock alert</h3>
            </div>
            {lowStockProducts.length === 0 ? (
              <p style={{fontSize:"13px",color:"var(--text3)"}}>All products well stocked</p>
            ) : lowStockProducts.map(p => (
              <div key={p._id} className={styles.stockRow}>
                <div>
                  <div className={styles.stockName}>{p.name}</div>
                  <div className={styles.stockCat}>{p.category}</div>
                </div>
                <span className={`badge ${p.stock === 0 ? "badge-red" : "badge-amber"}`}>{p.stock} left</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
